import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from '../forms/RecordForm';
import {ReportRun} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: ReportRun,
        handleSubmit: (values: ReportRun) => void
    }) => {

    const title = 'Create Report Run';

    const handleFormSubmit = async (values: ReportRun) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <Drawer
            transitionProps={{
                transition: 'slide-left',
                duration: 750,
                timingFunction: 'ease'
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    );
};
